<div class="card" [class.mt-5]="this.Spacer" data-testid="bundle-items-list">
  <div class="backdrop" *ngIf="IsWaiting">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h4 class="text-muted d-flex mb-4 mt-6">
        <strong>
          <span class="text-success">{{ this.bundleSet?.ItemsCount }} Items</span> in your Bundle
        </strong>
        <span class="blue-text"></span>
      </h4>
      <h5 class="grey-text" (click)="removeBundle(this.bundleSet?.BundleId)">
        <a data-testid="remove-bundle"> <i class="fa fa-trash" aria-hidden="true"></i> Remove </a>
      </h5>
    </div>

    <div class="d-flex justify-content-between align-items-center alert alert-success" role="alert" data-mdb-color="danger">
      <p class="mb-0">Your BUNDLED ITEMS have increased your savings by&nbsp;<strong><span>{{ this.bundleSet?.TotalSavings | currency }}</span></strong>!</p>
      <strong *ngIf="this.canEditBundle">
        <a href="" class="text-reset d-lg-block" (click)="showBundleBuilder($event)"
        data-testid="edit-bundle"> Edit</a>
      </strong>
    </div>

    <ng-container *ngIf="this.bundleSet?.Items">
      <div class="col">
        <div class="col" *ngFor="let p of this.bundleSet.Items">
          <!--Product row-->
          <div class="row d-flex p-2"
               [attr.data-testid]="'bundle-item-' + p.Webcode">
            <div class="col-lg-2 col-md-3 col-sm-3 col-xs-4">
              <h6 class="font-weight-bold mb-3">Product</h6>
              <img src="{{ getImageURL(p.ImageDataburst) }}" class="img-fluid" />
            </div>

            <div class="col-lg-4 col-md-4 col-sm-9 col-xs-12">
              <h6 class="font-weight-bold mb-3">Description</h6>
              <div>
                <small> {{ p.Description }}</small><br />
                <small class="text-muted">
                  <span [style.text-decoration]="p.Attributes.RegularPrice != p.UnitPrice && 'line-through'">
                    {{ p.Attributes.RegularPrice | currency }}
                  </span>
                  <strong class="red-text"
                  *ngIf="p.Attributes.RegularPrice > 0 && p.Attributes.RegularPrice != p.UnitPrice">
            SAVE {{ p.Attributes.RegularPrice - p.UnitPrice | currency }}
          </strong><br />
                  <div *ngFor="let discount of p.DiscountItems"
                       class="p-1 rounded-sm success-color text-white z-depth-1 mb-2">
                    {{ discount.Attributes.RuleName }}
                    <strong>{{ -discount.UnitPrice * discount.Quantity | currency }}</strong>
                  </div>
                  <div>Webcode: {{ p.Webcode }}</div>
                </small>
                  <div
                          *ngIf="p.IsDigitalItem"
                          class="badge green"
                          triggers="hover"
                          placement="right"
                          container="body"
                          mdbPopoverHeader="Digital Item"
                          mdbPopover="This item is digital. It will be delivered via email."
                  >
                      Digital Item <i class="fas fa-question-circle"></i>
                  </div>
              </div>
            </div>
            <div class="col" *ngIf="p.ParentRecordID"></div>
            <div class="col"
                 *ngIf="!p.ParentRecordID"
                 style="padding-right: 5px !important; padding-left: 5px !important">
              <!--style="white-space: nowrap;font: medium !important;"-->
              <div class="font-weight-bold mb-3">
                <i class="fa fa-check text-success" *ngIf="p.StockingStatus === 'In Stock'"></i>
                <!-- <span href="#" *ngIf="p.FinalSale" class="text-danger"
                title="Special Order items are ordered from the manufacturer and may take weeks to arrive. It requires a full, non-refundable payment.">
                <i class="fa fa-info-circle"></i> {{ p.StockingStatus}}

              </span>-->
                <span *ngIf="p.FinalSale"
                      class="badge red hand"
                      triggers="hover"
                      placement="top"
                      container="body"
                      mdbPopoverHeader="Special Order:"
                      mdbPopover="Special Order items are ordered from the manufacturer and may take weeks to arrive. It requires a full, non-refundable payment.">
                  Special order <i class="fas fa-info-circle"></i>
                </span>

                <span *ngIf="!p.FinalSale" style="width: 220px !important"> {{ p.StockingStatus }}</span>
              </div>
              <small *ngIf="p.StockingStatus === 'In Stock'">Ready to Ship</small>
            </div>

            <div class="col" style="padding-right: 5px !important; padding-left: 5px !important">
              <h6 class="font-weight-bold mb-3">Qty</h6>

              <input
                     type="number"
                     [(ngModel)]="p.Quantity"
                     [readonly]="p.ParentRecordID"
                     (change)="changeItemQuantity(p, $event)"
                     aria-label="Quantity"
                     class="form-control"
                     data-test='product-quantity'
                     style="width: 65px"
                     min="1" />
            </div>

            <div class="col" style="padding-right: 5px !important; padding-left: 5px !important">
              <h6 class="font-weight-bold mb-3">Item Total</h6>
              <strong>{{ (p.Attributes.IsBundleFreeItem ? p.LineTotal : p.Quantity * p.UnitPrice) | currency }}</strong>
            </div>
          </div>
          <!-- Product Row  buttons -->
          <div class="row d-flex border-bottom" style="padding-bottom: 10px">
            <!--*ngIf="p.DisplayMin"-->

            <div class="col-6 d-flex justify-content-start"
                 *ngIf="!p.Attributes.IsBundleFreeItem && !p.IsLastAnchorItem">
              <div class="small hand btnItem" (click)="removeItem(p)" data-test='remove-item'>
                <mdb-icon far icon="trash-alt"></mdb-icon> Remove
              </div>
            </div>
            <div *ngIf="!p.IsLastAnchorItem && !p.ParentRecordID && !p.Attributes.IsBundleFreeItem"
                 class="col-6 d-flex justify-content-end">
              <div class="small hand btnItem" (click)="saveItemForLater(p)" data-testid='save-item'>
                <mdb-icon far icon="clock"></mdb-icon> Save Item
              </div>
            </div>
          </div>
          
          <app-service-plans-row
            [parentItemWebCode]="p.Webcode"
            [servicePlans]="p.ServicePlans"
            [isOnCartPage]="true"
          ></app-service-plans-row>

        </div>
        <!-- Bundle Totals -->
        <div class="row d-flex p-2 text-end">
          <div class="col-lg-7"></div>
          <div class="col-lg-3 col-6">
            Bundle Savings: <br />
            <strong>Bundle Total: </strong>
          </div>
          <div class="col-lg-2 col-6">
            <strong class="text-success">{{ this.bundleSet.TotalSavings | currency }}</strong><br />
            <strong>{{ this.bundleSet.Total | currency }}</strong>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
